// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge__badge__mHLqp","success":"Badge__success__ZIzMm","text":"Badge__text__nIAui"};